// static UI
import Box from 'UIKit/Box/Box'
import Flex from 'UIKit/Box/Flex'
import Text from 'UIKit/Text/Text'
import { BonusTagEnums } from 'config/types/bonus'
import { WageringConditionBonus } from 'config/types/bonus/userBonus'
import React from 'react'
import { Trans } from 'react-i18next'
import styled from 'styled-components'
import { Icons } from 'svgs'
import { colors } from 'theme/colors'
import BonusInvalid from 'views/BonusCenter/components/BonusInvalid'
import UpcomingBonus from 'views/BonusCenter/components/UpcomingBonus'
import BonusAction from '../../BonusAction'
import BonusItemCountdown from '../../BonusItemCountdown'

interface BonusItemProps {
  bonus: WageringConditionBonus
}

const MakeSpinBonusContent: React.FC<BonusItemProps> = ({ bonus }) => {
  return (
    <Flex flexDirection="column" justifyContent="space-between" height="100%">
      <Flex>
        <Box>
          <Text color="textSubtle" fontSize="10px" fontWeight="300">
            <Trans>Min Deposit</Trans>
          </Text>

          {bonus.tags.includes(BonusTagEnums.NoDeposit) ? (
            <Text fontWeight="600" fontSize="12px" mt="6px">
              <Trans>No deposit</Trans>
            </Text>
          ) : (
            <Flex alignItems="center" mt="4px">
              <Icons.SuccessIcon width="14px" fill={colors.text} />
              <Text fontWeight="600" fontSize="12px" ml="4px">
                <Trans>Done</Trans>
              </Text>
            </Flex>
          )}
        </Box>
        <Box ml="20px">
          <Text color="textSubtle" fontSize="10px" fontWeight="300">
            <Trans>Wager</Trans>
          </Text>
          <Text fontWeight="600" fontSize="12px" mt="8px">
            x{bonus.wagerMultiplier}
          </Text>
        </Box>
      </Flex>

      <Flex width="100%" mt="20px">
        {bonus.condition.isExpired ? (
          <StyledBonusInvalid bonus={bonus} />
        ) : (
          <>
            <BonusItemCountdown expiryDate={bonus.condition.expiryDate} />
            <Box width="8px" />
            <BonusAction bonus={bonus} />
          </>
        )}
      </Flex>

      {bonus.bonusUpcoming?.length > 0 && <UpcomingBonus mt="20px" bonus={bonus} />}
    </Flex>
  )
}

const StyledBonusInvalid = styled(BonusInvalid)`
  height: 40px;
  border-radius: 8px;
  white-space: nowrap;
  box-sizing: border-box;
  padding: 0px !important;
  flex: 1 1;
  font-size: 14px;
  font-weight: bold;
`

export default MakeSpinBonusContent
